import React from "react";

import { fetchBCalSchedule } from "data/actions/bCalScheduleActions";
import { getMyStatus } from "data/slices/myStatus";

import { Card, CardTitle, CardBody } from "components/ui/Card";
import Spinner from "components/ui/Spinner";
import NoBconnected from "../NoBconnected";
import BCalScheduleItems from "components/cards/BCalScheduleCard/BCalScheduleItems";
import AccessibleLinkContent from "components/ui/AccessibleLinkContent";

import { dispatchSlice } from "components/hooks/dispatchSlice";
import { useSlice } from "components/hooks/useSlice";

// https://wikihub.berkeley.edu/display/SIS/CalCentral+bCal+Schedule+Card
export function BCalScheduleCard() {
  dispatchSlice(fetchBCalSchedule);
  dispatchSlice(getMyStatus);

  const { items = [], isLoading, error = null } = useSlice("bCalSchedule");
  const { hasGoogleAccessToken = false, officialBmailAddress = null } =
    useSlice("myStatus");

  const hasItems = items.length > 0;

  return (
    <Card data-testid="bcal-schedule-card">
      <CardTitle>
        <h2>bCal Schedule</h2>
      </CardTitle>

      {isLoading ? (
        <CardBody>
          <Spinner />
        </CardBody>
      ) : error ? (
        <CardBody>error</CardBody>
      ) : hasItems ? (
        <BCalScheduleItems />
      ) : hasGoogleAccessToken ? (
        <CardBody>
          You have no events scheduled for the rest of the day.
        </CardBody>
      ) : officialBmailAddress ? (
        <CardBody>
          <NoBconnected mode="upnext" />
        </CardBody>
      ) : (
        <CardBody>
          Our records indicate that you do not currently have a bConnected
          account (UC Berkeley email and calendar). Visit{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://mybconnected.berkeley.edu/manage/account/create_account"
          >
            <AccessibleLinkContent showNewWindow={true}>
              bConnected
            </AccessibleLinkContent>
          </a>{" "}
          to create your bConnected account.
        </CardBody>
      )}
    </Card>
  );
}
BCalScheduleCard.displayName = "BCalScheduleCard";
